import createKaraokePlayerRoute from "../create-karaoke-player-route";

import MusicArchive from "../../../../views/digibord/content/archive/MusicArchive.vue";

export default [
  {
    path: "muziekarchief/",
    name: "MusicArchive",
    component: MusicArchive,
    meta: {
      containerClass: "showSongSearch",
    },
    children: [...createKaraokePlayerRoute("MusicArchiveKaraokePlayer")],
  },
];
